import { render, staticRenderFns } from "./wtRadiobox.component.vue?vue&type=template&id=46c547b9&"
import script from "./wtRadiobox.component.vue?vue&type=script&lang=js&"
export * from "./wtRadiobox.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports